import { Button } from "@mui/material";
import React from "react";
import { buttonStyles, secondaryButtonStyles } from "./navigationButton.style";

const ActionButton = ({
    label,
    triggerFunction,
    icon,
    iconPosition = "start",
    style,
    disabled,
    isSecondary,
}: {
    label: string;
    triggerFunction?: () => void;
    icon?: React.ReactNode;
    iconPosition?: "start" | "end";
    style?: any;
    disabled?: boolean;
    isSecondary?: boolean;
}) => {
    const buttonStyle = isSecondary ? secondaryButtonStyles : buttonStyles;

    return (
        <>
            {iconPosition === "start" ? (
                <Button
                    onClick={triggerFunction}
                    variant="outlined"
                    startIcon={icon}
                    sx={{
                        ...buttonStyle,
                        width: style?.width ? style.width : buttonStyle.width,
                        height: style?.height ? style.height : undefined,
                    }}
                    disabled={disabled}
                >
                    {label}
                </Button>
            ) : (
                <Button
                    onClick={triggerFunction}
                    variant="outlined"
                    endIcon={icon}
                    sx={{
                        ...buttonStyle,
                        width: style?.width ? style.width : buttonStyle.width,
                        height: style?.height ? style.height : undefined,
                    }}
                    disabled={disabled}
                >
                    {label}
                </Button>
            )}
        </>
    );
};

export default ActionButton;
